import React from 'react';

import Accordion from '~/components/accordion/accordion';

import styles from '~/components/lawns/lawns.module.scss';

const SizeGuideAccordion = () => {
  return (
    <Accordion
      buttonContent="Lawn size guide"
      buttonClassName={styles.sizeGuideAccordionButton}
    >
      <ul className={styles.sizeGuideList}>
        <li>
          A <strong>two-car garage</strong> is about{' '}
          <strong> 500 square feet</strong>
        </li>
        <li>
          A <strong>tennis court</strong> is about{' '}
          <strong>2,000 square feet</strong>
        </li>
        <li>
          A <strong>basketball court</strong> is about{' '}
          <strong>5,000 square feet</strong>
        </li>
        <li>
          A <strong>1/4 acre</strong> is about{' '}
          <strong>10,000 square feet</strong>
        </li>
        <li>
          A <strong>1/2 acre</strong> is about{' '}
          <strong>20,000 square feet</strong>
        </li>
        <li>
          A <strong>little less than 3/4 acre</strong> is about{' '}
          <strong>30,000 square feet</strong>
        </li>
      </ul>
    </Accordion>
  );
};

export default SizeGuideAccordion;
